import { FeatureProviderContext } from "@origin-digital/features";

export const isFeatureEnabled = (
  featureContext: Pick<FeatureProviderContext, "features"> | undefined,
  featureName: string
) => {
  const featureFound =
    featureContext &&
    featureContext.features.find(
      (feature: any) => feature.name === featureName
    );
  return (featureFound && featureFound.enabled) || false;
};

export const MOVERS_COMP_TOGGLE = "sales-core-movers-competition-campaign";
